import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {UpdateActiveStep} from "../../../../redux/actions/tourActions";
import {STEPS} from "../../helpers";
import {GetExtensionLinkService} from "../../../../redux/actions";
import {Tour} from "antd";
import './TourFourStep.scss';
import {detectExtensionPromise} from "../../../../utils/helperFunctions";
import {useTourActions} from "../../hooks";

const TourFourStep = () => {
    const dispatch = useDispatch();
    const activeStep = useSelector((state) => state.tour?.activeStep);
    const {t} = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const [step, setStep] = useState(0);
    const [installExtension, setInstallExtension] = useState(false);
    const {handleClickNextStep4} = useTourActions();

    useEffect(() => {
        if(activeStep === STEPS.FOUR){
            setStep(0);
        }
    }, [activeStep])

    const stepsArr = [
        {
            title: t('tour_step_4'),
            description: t('tour_step_4_desc'),
            target: () => document.getElementById(`service-list-extension`),
            nextButtonProps:{
                children: <div className="button-next">
                    <div className="button-next--later">{t('later')}</div>
                    <span className="button-next--next" onClick={()=>{
                        GetExtensionLinkService().then((res) => {
                            window.open(res?.link, '_blank');
                        })
                    }}
                    >
                        {t('install')}
                    </span>
                </div>,
                onClick: () => {
                    setStep(1)
                }
            },
            placement: 'right'
        },
        {
            title: t('tour_step_4_1'),
            description: t('tour_step_4_1_desc'),
            target: () => document.getElementById(`service-list-telegram`),
            nextButtonProps:{
                children: <span>{t('next')}</span>,
            },
            prevButtonProps:{
                children: null,
            },
            placement: 'right'
        },
        {
            title: t('tour_step_4_2'),
            description: t('tour_step_4_2_desc'),
            target: () => document.getElementById(`service-list-confluence`),
            nextButtonProps:{
                children: <span>{t('next')}</span>,
                onClick: () => handleClickNextStep4()
            },
            placement: 'right'
        }
    ];
    const [steps, setSteps] = useState(stepsArr);

    const detectExtension = async () => {
        const result = await detectExtensionPromise();
        setInstallExtension(result);
    }

    useEffect(()=>{
        if([STEPS.FOUR].includes(activeStep)){
            detectExtension();
            setTimeout(async ()=>{
                const result = await detectExtensionPromise();
                if(result){
                    setSteps(stepsArr.slice(1));
                }else{
                    setSteps(stepsArr)
                }

                window.scrollTo({
                    top: 3000
                })
                setIsOpen(true)
            },500)
        }else{
            setIsOpen(false)
        }
    },[activeStep])

    return (
            <Tour
                rootClassName={`${(step === 0 && !installExtension) ? 'tour-four' : ''}`}
                indicatorsRender={(current, total) => (
                    <span>
                      {current + 1} / {total}
                     </span>
                )}
                onChange={(num)=>setStep(num)}
                placement="left"
                open={isOpen}
                onClose={() => {
                    dispatch(UpdateActiveStep(null));
                    setIsOpen(false)
                    setStep(0);
                }}
                steps={steps}
                gap={{radius: 12, offset: 4 }}
            />
    );
};

export default TourFourStep;